function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.0267 13.4647C11.3577 13.4647 10.6907 13.2437 10.1327 12.8017L5.64773 9.18574C5.32473 8.92574 5.27473 8.45274 5.53373 8.13074C5.79473 7.80974 6.26673 7.75874 6.58873 8.01774L11.0697 11.6297C11.6327 12.0757 12.4257 12.0757 12.9927 11.6257L17.4287 8.01974C17.7507 7.75674 18.2227 7.80674 18.4847 8.12874C18.7457 8.44974 18.6967 8.92174 18.3757 9.18374L13.9317 12.7957C13.3697 13.2417 12.6977 13.4647 12.0267 13.4647Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.25 2H22.7499V21.5H1.25V2Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1486_835)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.089 20H16.909C16.911 19.998 16.919 20 16.925 20C18.066 20 19.078 19.592 19.854 18.817C20.755 17.92 21.25 16.631 21.25 15.188V8.32C21.25 5.527 19.424 3.5 16.909 3.5H7.091C4.576 3.5 2.75 5.527 2.75 8.32V15.188C2.75 16.631 3.246 17.92 4.146 18.817C4.922 19.592 5.935 20 7.075 20H7.089ZM7.072 21.5C5.529 21.5 4.151 20.94 3.087 19.88C1.902 18.698 1.25 17.032 1.25 15.188V8.32C1.25 4.717 3.761 2 7.091 2H16.909C20.239 2 22.75 4.717 22.75 8.32V15.188C22.75 17.032 22.098 18.698 20.913 19.88C19.85 20.939 18.471 21.5 16.925 21.5H16.909H7.091H7.072Z",
  fill: "currentColor"
}));

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1486_835",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 22,
    height: 20
  }, _ref3), _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.ff978e78.svg";
export { ForwardRef as ReactComponent };